/* eslint-disable no-undef */
/* eslint-disable no-nested-ternary */
import axios from 'axios'

export default async function bcsFetch(data, action, contentType = null, queryParam = null) {
  const response = await axios({
    url: typeof bc_inventory_connector === 'undefined' ? bcFormsFront.ajaxURL : bc_inventory_connector.ajaxURL,
    method: 'POST',
    headers: {
      'Content-Type': contentType === null ? 'application/x-www-form-urlencoded' : contentType,
    },
    params: {
      action,
      _ajax_nonce: typeof bc_inventory_connector === 'undefined' ? '93367f5359' : bc_inventory_connector.nonce,
      ...queryParam,
    },
    data,
    action,
  })
    .then(res => res.data)
    .catch(err => err.response)
  return response;
}
